export const gradient = {
  brand: `linear-gradient(135deg, #ff7a4d 0%, #ff2526 100%)`,
  teal: `linear-gradient(180deg, #1fd8b5 0%, #23aeb9 100%)`,
  gold: `linear-gradient(180deg, #ffc672 0%, #df9523 100%)`,
  black: `linear-gradient(180deg, #383838 0%, #111010 100%)`,
  blue: `linear-gradient(180deg, #65aeff 0%, #007aff 100%)`,
};
